import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
    &copy; Loa ISound v1.0 2024 
    </span>
  `,
})
export class FooterComponent {
}
